/**
 * Derive a stable slug value from a display label.
 * e.g. "Voorstel gestuurd" → "voorstel-gestuurd"
 *
 * Used by the settings page to derive the value of a new sponsoring stage.
 */
export const toSlug = (label: string): string =>
  label
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
